import { Module } from "./index"
import * as paths from "constants/paths"
import * as modules from "constants/features"
import CustomerBehavior from "components/CustomerBehavior"
import SwitchersOut from "components/CustomerBehavior/Switching/SwitchersOut"
import SwitchingByProducts from "components/CustomerBehavior/Switching/SwitchingByProducts"
import SwitchingBreakdown from "components/CustomerBehavior/Switching/SwitchingBreakdown"
import CustomerProfiling from "components/CustomerBehavior/CustomerProfiling"

const CustomerBehaviorModule: Module = {
	module: modules.CUSTOMER_BEHAVIOR_MODULE,
	component: CustomerBehavior,
	path: paths.CUSTOMER_BEHAVIOR,
	submodules: [
		{
			module: modules.CUSTOMER_BEHAVIOR_CUSTOMER_PROFILING_SUBMODULE,
			component: CustomerProfiling,
			path: paths.CUSTOMER_PROFILING_SEGMENTATION_SUMMARY,
		},
		{
			module: modules.CUSTOMER_PROFILING_SEGMENTATION_SUMMARY_SUBMODULE,
			component: CustomerProfiling,
			path: paths.CUSTOMER_PROFILING_SEGMENTATION_SUMMARY,
		},
		{
			module: modules.CUSTOMER_PROFILING_DEMOGRAPHIC_SEGMENTATION_SUBMODULE,
			component: CustomerProfiling,
			path: paths.CUSTOMER_PROFILING_DEMOGRAPHIC_SEGMENTATION,
		},
		{
			module: modules.CUSTOMER_PROFILING_HABITS_SEGMENTATION_SUBMODULE,
			component: CustomerProfiling,
			path: paths.CUSTOMER_PROFILING_HABITS_SEGMENTATION,
		},
		{
			module: modules.CUSTOMER_SWITCHING_GENERAL_METRICS_SUBMODULE,
			component: SwitchingBreakdown,
			path: paths.CUSTOMER_BEHAVIOR_SWITCHING_BREAKDOWN,
		},
		{
			module: modules.CUSTOMER_SWITCHING_SWITCHERS_IN_SUBMODULE,
			component: SwitchingByProducts,
			path: paths.CUSTOMER_BEHAVIOR_SWITCHING_SWITCHING_BY_PRODUCTS,
		},
		{
			module: modules.CUSTOMER_SWITCHING_SWITCHERS_OUT_SUBMODULE,
			component: SwitchersOut,
			path: paths.CUSTOMER_BEHAVIOR_SWITCHING_SWITCHERS_OUT,
		},
	],
}

export default CustomerBehaviorModule
